import React from "react";
import { useField } from "formik";
import { TextField, Typography, TextFieldProps } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { upperFirst } from "../../utils/upperFirst";

export type CustomFormInputProps = {
  name: string;
  label: string;
  type?: string;
  value?: string | number;
  onFocus?: React.EventHandler<
    React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>
  >;
};

const useStyles = makeStyles({
  input: {
    marginTop: 4,
  },
  label: {
    position: "relative",
  },
});

const FormInput: React.FC<CustomFormInputProps & TextFieldProps> = ({
  InputProps,
  ...props
}) => {
  const { name, type, label, onFocus } = props;
  const classes = useStyles();
  const [field, meta] = useField(name);
  const { error, touched } = meta;

  return (
    <>
      <TextField
        {...field}
        {...props}
        InputProps={{
          labelWidth: 0,
          notched: false,
          fullWidth: true,
          className: classes.input,
          inputProps: {
            autoCorrect: "none",
            autoCapitalize: "none",
          },
          ...InputProps,
        }}
        InputLabelProps={{
          shrink: true,
          variant: "outlined",
          className: classes.label,
        }}
        label={label}
        data-testid={`input${upperFirst(name)}`}
        variant="outlined"
        type={type}
        helperText={
          !!touched &&
          !!error && (
            <Typography
              component="span"
              variant="body2"
              data-testid={`error${upperFirst(name)}`}
            >
              {error}
            </Typography>
          )
        }
        onFocus={onFocus}
        fullWidth={true}
        error={!!touched && !!error}
      />
    </>
  );
};

export default FormInput;
